<div class="ag-header-group-cell-label display-flex flex-align-center full-height full-width" ref="agContainer" role="presentation">
  <app-metric-dimension-name [item]="params.item"></app-metric-dimension-name>
</div>
